export default __webpack_public_path__ + "static/media/pipe1.01d53697.jpg";